module.exports = __webpack_public_path__ + "static/media/GunaldiHeroFinal.a661ae66.svg";